module.exports = __webpack_public_path__ + "static/media/boat-img-45.e8c41450.jpg";